import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'
import { OrderCard } from '../../components/order-card'
import { type OrderModel } from '../../model/order-model'

interface Props {
  order: OrderModel
}
export const AdminOrderBrands = (props: Props) => {
  const childOrders = props.order.getChildOrders()
  const { t } = useTranslation()

  return (
    <VStack width="100%" backgroundColor={colors.white} p={3} gap={4}>
      <Text variant="h5">{t('product.purchaseItems')}</Text>
      {Object.keys(childOrders).map((project) => {
        return (
          <OrderCard
            key={project}
            projectCode={project}
            childOrders={childOrders?.[project] ?? []}
          />
        )
      })}
    </VStack>
  )
}
